
import React, {useEffect, useState} from 'react';
import {session_total_cost} from '../../../service/basket'
import rombus from '../../../media/rombus.gif'

const SessionTotalCostBlock = ({client_id, agent_id,prod_type=null, date_from=null, date_to=null, title=null, sub_title=null, token, timeout}) => {

    const [count_v, set_d_count] = useState(null);

    const  popd = (client_id, agent_id, date_from, date_to, prod_type) => {
        const limit = 8;
        setTimeout(() => {
            session_total_cost(client_id, agent_id, date_from, date_to, prod_type, token).then((d) => {
            if(d != null){
                set_d_count(d)
            }
            });     
        }, timeout);

    }
    

    let cTitle = 'Potential total value';
    if(title != null){
        cTitle = title;
    }

    let cSubTitle = 'Abandoned baskets total value';
    if(sub_title != null){
        cSubTitle = sub_title;
    }


    useEffect(() =>{
        set_d_count(null);
        popd(client_id, agent_id,date_from, date_to, prod_type);
    }, [client_id, agent_id, date_from, date_to, prod_type])


    if(count_v == null){
        return <>
            <div className='countBlock'>
                <div className='countBlockTitle'>
                    {cTitle}
                </div>
                <div className='countBlockContent'>
                    <div style={{justifyContent: 'center'}}>
                            <img src={rombus}></img>
                    </div>
                </div>
            </div>
        </>
    }
    const cost_dr = Math.round(count_v);
    const formatted = Number(cost_dr).toLocaleString('en-US');

    return (<div className='countBlock'>
        <div className='countBlockTitle'>
            {cTitle}
        </div>
        <div className='countBlockContent'>
            <div className='info'>{formatted}</div>
            <div className='info infosmall'>{cSubTitle}</div>
        </div>
    </div>)

}

export default SessionTotalCostBlock
